import { render } from "./BuyerFormFields.vue?vue&type=template&id=295956e2"
import script from "./BuyerFormFields.vue?vue&type=script&lang=js"
export * from "./BuyerFormFields.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__